import type { ReceiveReleaseLookupField } from '@/entities/receive';
import { SuggestInput } from '@/shared/ui';

import { RELEASE_GOODS_TEXT_MAX_LENGTH } from '../model/constants';
import { useReleaseLookups } from '../model/use-release-lookups';

interface ReleaseGoodsLookupInputProps {
  id: string;
  field: ReceiveReleaseLookupField;
  value: string;
  onChange: (value: string) => void;
  onBlur: () => void;
  placeholder: string;
}

/** A handover field: free text, with values from earlier releases offered as the operator types. */
export function ReleaseGoodsLookupInput({ field, value, ...inputProps }: ReleaseGoodsLookupInputProps) {
  const suggestions = useReleaseLookups(field, value);

  return (
    <SuggestInput value={value} suggestions={suggestions} maxLength={RELEASE_GOODS_TEXT_MAX_LENGTH} {...inputProps} />
  );
}
